<nav class="navbar">
  <div class="nav-container">
    <!-- Mobile: Logo left -->
    <div class="mobile-left">
      <img src="/logo.png" alt="Restless Society" class="logo-image" width="360" height="360">
    </div>

    <!-- Desktop: Left section -->
    <div class="nav-left">
      <a routerLink="/" class="logo-link">
        <img src="/logo.png" alt="Restless Society" class="logo-image" width="360" height="360">
      </a>
      <a routerLink="/about" routerLinkActive="active" class="nav-link">
        About
      </a>
      <a routerLink="/events" routerLinkActive="active" class="nav-link">
        Events
      </a>
      <a routerLink="/community-news" routerLinkActive="active" class="nav-link">
        News
      </a>
      <a routerLink="/playlists" routerLinkActive="active" class="nav-link">
        Playlists
      </a>
      <a routerLink="/newsletter" routerLinkActive="active" class="nav-link">
        Newsletter
      </a>
    </div>

    <!-- Center icon (both mobile and desktop) -->
    <a routerLink="/" class="center-icon">
      <img src="/icon.png" alt="Restless Society Icon" width="737" height="267">
    </a>

    <!-- Desktop: Right section -->
    <div class="nav-right">
      <button type="button" class="theme-toggle" (click)="toggleTheme()" aria-label="Toggle dark mode" [attr.aria-pressed]="isDarkMode$ | async" title="Toggle theme">
        <svg *ngIf="!(isDarkMode$ | async)" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
        <svg *ngIf="(isDarkMode$ | async)" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="5"></circle>
          <line x1="12" y1="1" x2="12" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="23"></line>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
          <line x1="1" y1="12" x2="3" y2="12"></line>
          <line x1="21" y1="12" x2="23" y2="12"></line>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
      </button>

      <!-- <button *ngIf="!(isRegularUser$ | async)" class="btn btn-secondary sign-in-link" (click)="openAuthModal()">
        Sign In
      </button> -->

      <div *ngIf="(isRegularUser$ | async) && (authService.user$ | async) as user" class="user-menu">
        <button class="user-icon-button" (click)="toggleUserDropdown()" aria-label="Account menu" [attr.aria-expanded]="showUserDropdown">
          <i class="bi bi-person-circle"></i>
          <i class="bi bi-chevron-down dropdown-arrow"></i>
        </button>
        <div class="user-dropdown" *ngIf="showUserDropdown" @slideInUp>
          <div class="user-info">
            <span class="user-name">{{ user.displayName || 'User' }}</span>
          </div>
          <a class="dropdown-link" (click)="openSettings()">
            <i class="bi bi-gear"></i> Settings
          </a>
          <a class="dropdown-link" (click)="logout()">
            <i class="bi bi-box-arrow-right"></i> Logout
          </a>
        </div>
      </div>

      <button class="btn btn-primary subscribe-button" (click)="navigateToSubscribe()">
        Subscribe
      </button>
    </div>

    <!-- Mobile: Right controls -->
    <div class="mobile-right">
      <button type="button" class="theme-toggle" (click)="toggleTheme()" aria-label="Toggle dark mode" [attr.aria-pressed]="isDarkMode$ | async" title="Toggle theme">
        <svg *ngIf="!(isDarkMode$ | async)" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
        <svg *ngIf="(isDarkMode$ | async)" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="5"></circle>
          <line x1="12" y1="1" x2="12" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="23"></line>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
          <line x1="1" y1="12" x2="3" y2="12"></line>
          <line x1="21" y1="12" x2="23" y2="12"></line>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
      </button>
      <button 
        class="hamburger mobile-menu-toggle"
        (click)="toggleMenu()"
        [attr.aria-label]="isMenuOpen ? 'Close menu' : 'Open menu'"
        [attr.aria-expanded]="isMenuOpen"
      >
        <input type="checkbox" [checked]="isMenuOpen">
        <svg viewBox="0 0 32 32">
          <path class="line line-top-bottom" d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"></path>
          <path class="line" d="M7 16 27 16"></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Mobile menu overlay -->
  <div class="mobile-menu-overlay" *ngIf="isMenuOpen" (click)="closeMenu()"></div>
  
  <!-- Mobile menu -->
  <div class="mobile-menu" *ngIf="isMenuOpen" @slideInUp>
    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" 
       class="mobile-nav-link" (click)="closeMenu()">
      Home
    </a>
    <a routerLink="/about" routerLinkActive="active" class="mobile-nav-link" (click)="closeMenu()">
      About
    </a>
    <a routerLink="/events" routerLinkActive="active" class="mobile-nav-link" (click)="closeMenu()">
      Events
    </a>
    <a routerLink="/community-news" routerLinkActive="active" class="mobile-nav-link" (click)="closeMenu()">
      Community News
    </a>
    <a routerLink="/playlists" routerLinkActive="active" class="mobile-nav-link" (click)="closeMenu()">
      Playlists
    </a>
    <a routerLink="/newsletter" routerLinkActive="active" class="mobile-nav-link" (click)="closeMenu()">
      Newsletter
    </a>
    <!-- <button *ngIf="!(isRegularUser$ | async)" class="mobile-nav-link" (click)="openAuthModal()">
      Sign In
    </button> -->
    <div *ngIf="(isRegularUser$ | async) && (authService.user$ | async) as user" class="mobile-user-menu">
      <div class="mobile-user-info">
        <i class="bi bi-person-circle"></i>
        <span class="user-name">{{ user.displayName || 'User' }}</span>
      </div>
      <a class="mobile-logout-link" (click)="openSettings()">
        <i class="bi bi-gear"></i> Settings
      </a>
      <a class="mobile-logout-link" (click)="logout(); closeMenu()">
        <i class="bi bi-box-arrow-right"></i> Logout
      </a>
    </div>
    <button class="btn btn-primary mobile-subscribe-button" (click)="navigateToSubscribe()">
      Subscribe
    </button>
  </div>
</nav>

<app-auth-modal *ngIf="showAuthModal" (close)="closeAuthModal()"></app-auth-modal>
<app-settings-modal *ngIf="showSettingsModal" (close)="closeSettings()"></app-settings-modal>
